// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';
import { fang } from '@Helpers/observable';
import { cutString } from '@Helpers/string';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import RouteBuilder from '@Services/RouteBuilder';
import React, { ReactElement } from 'react';
import { ObservableOutput } from 'thehive-sdk';
import { CardContentProps } from '../CardContentType';

const formatObservableTitle = ({ data, attachment }: Partial<ObservableOutput>): string =>
    data ? cutString(fang(data), 255) : attachment?.name ? fang(attachment?.name) : '';

export const JobContent = ({ data, base }: CardContentProps): ReactElement | null => {
    const local = useLocalMessage();
    const { action, _id: baseId, details, context } = base;
    const { observable } = data || {};
    const { case: caseData, alert: alertData } = observable || {};

    const title = data['analyzerName'] || '';

    const path = caseData
        ? RouteBuilder.compute('cases.observable', {
              caseId: caseData._id,
              observableId: observable._id,
          })
        : undefined;

    const customDetails = {
        ...(observable ? { observable: { title: formatObservableTitle(observable), path } } : {}),
        status: action === 'create' ? 'Started' : details.status,
        cortexId: details.cortexId,
        startDate: details.startDate,
        endDate: details.endDate,
    };

    const titleComplement = action === 'create' ? '' : ` [${local('stream.terminated')}]`;

    if (action !== 'create') {
        delete customDetails.startDate;
    } else {
        delete customDetails.endDate;
    }

    return (
        <StreamCard
            icon={<ICONS.JobIcon />}
            title={title + titleComplement}
            base={base}
            information="job"
            parent={caseData || alertData || context}
        >
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={baseId + key} prop={key} value={value} type="job" />
            ))}
        </StreamCard>
    );
};
